/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase, { readSaleReport, readSaleContext } from '@/services/saleData';
import { invalidateReport, currentReport } from '@/services/reportRange';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
import axios from 'axios';
export default {
  async fetchBonus (context, {datestart, dateend}) {
    return activeReport(context, 'SET_REGISTER', async () => {
      const members = await referralMembers();
      const codes = new Set(members.map(user => user.code));
      const [history, spin] = await Promise.all([
        reportRows('history', datestart, dateend, [['type', '==', 'ฝาก'], ['status', '==', 'ดำเนินการแล้ว']]),
        reportRows('spin', datestart, dateend)
      ]);
      const bonus = history.filter(row => codes.has(row.code) && amount(row.bonus) > 0).map(row => ({
        ...row, value: row.bonus, admin: row.employeeDisplayName || '',
        bonustype: row.bonustype || (row.bonustoday && row.bonustoday.text) || '', type: 'credit'
      }));
      for (const row of spin) if (codes.has(row.code)) bonus.push({...row, bonustype: row.game, admin: row.employeeDisplayName || ''});
      return _.orderBy(bonus, ['createdate'], ['desc']);
    });
  },
  fetchUsersRoulet ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_ROULET', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('status').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().code] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('roulet').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.code]){
              data.firstname = users[data.code].firstname;
              data.lastname = users[data.code].lastname;
              data.code = users[data.code].code;
              data.pictureUrl = users[data.code].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_ROULET', spin);
        });
        resolve(true)
    });
  },
  fetchUsersSpin ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_SPIN', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('status').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().code] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('spin').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.code]){
              data.firstname = users[data.code].firstname;
              data.lastname = users[data.code].lastname;
              data.code = users[data.code].code;
              data.pictureUrl = users[data.code].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_SPIN', spin);
        });
        resolve(true)
    });
  },
  fetchUsersAdmin ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_SPIN', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const spin = [];
        await firebase.firestore().collection('adminkindness').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.pictureUrl = users[data.userId].pictureUrl;
              spin.push(data);
            }
          });
          commit('SET_ADMIN', spin);
        });
        resolve(true)
    });
  },
  fetchUsersRedeem ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_REDEEMS', []);
        const users = []; 
        await firebase.database().ref().child('users').orderByChild('calculate').equalTo('Y').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            users[data.val().userId] = data.val();
          });
        });
        const rewards = []; 
        await firebase.database().ref().child('rewards').once('value', async (snapshot) => {
          snapshot.forEach((data) => {
            rewards[data.key] = data.val();
          });
        });
        const redeems = [];
        await firebase.firestore().collection('redeemreward').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            const data = doc.data();
            if(users[data.userId] && rewards[data.rewardId]){
              data.firstname = users[data.userId].firstname;
              data.lastname = users[data.userId].lastname;
              data.code = users[data.userId].code;
              data.rewardname = 'ใช้ '+data.coin+' แลก '+data.credit+' เครดิต';
              data.pictureUrl = users[data.userId].pictureUrl;
              redeems.push(data);
            }
          });
          commit('SET_REDEEMS', redeems);
        });
        resolve(true)
      
    });
  },
  async fetchUsers (context, {datestart, dateend}) {
    return activeReport(context, 'SET_USERS', async () => {
      const members = await referralMembers();
      const [deposits, withdrawals, history, roulet, spin] = await Promise.all([
        reportRows('krungsri', datestart, dateend, [['status', '==', 'ดำเนินการแล้ว']]),
        reportRows('history', datestart, dateend, [['status', '==', 'ดำเนินการแล้ว'], ['type', '==', 'ถอน']]),
        reportRows('history', datestart, dateend, [['status', '==', 'ดำเนินการแล้ว'], ['type', '==', 'ฝาก']]),
        reportRows('roulet', datestart, dateend), reportRows('spin', datestart, dateend)
      ]);
      const depositTotals = totalsByCode(deposits, 'qty'), withdrawTotals = totalsByCode(withdrawals, 'qty');
      const historyBonuses = totalsByCode(history, 'bonus'), rouletBonuses = totalsByCode(roulet, 'value'), spinBonuses = totalsByCode(spin, 'value');
      return _.orderBy(members.filter(user => user.status === 'Y').map(user => {
        const deposit = depositTotals.get(user.code) || 0;
        const withdraw = withdrawTotals.get(user.code) || 0;
        const bonus = (historyBonuses.get(user.code) || 0) + (rouletBonuses.get(user.code) || 0) + (spinBonuses.get(user.code) || 0);
        return {...user, deposit, withdraw, bonus, total: deposit - withdraw};
      }).filter(user => user.deposit || user.withdraw || user.bonus), ['deposit'], ['desc']);
    });
  },
  fetchHuay ({ commit },{datestart,dateend}){
    return new Promise( async (resolve) => {
      commit('SET_USERS', []);
      let users = []
      await firebase.firestore().collection('huays').where('date','>=',datestart).where('date','<=',dateend).get().then((snapshot)=>{
        snapshot.forEach((doc) => {
          const data = doc.data();
          let text = '';
          for(const x in data.huays){
            text += (text)?', '+data.huays[x]:data.huays[x];
          }
          data.huay = text;
          users.push(data);
        });
        users = _.orderBy(users, ['updatetime'],['desc']);
        commit('SET_USERS', users);
        resolve(true)
      });
    });
  },
  async fetchPartner (context, {datestart, dateend}) {
    return activeReport(context, 'SET_USERS', async () => {
      const {code} = await readSaleContext();
      const members = await referralMembers(code);
      const codes = new Set(members.map(user => user.code));
      const friends = await firebase.firestore().collection('friends').where('code', '==', code).get();
      friends.forEach(doc => { if (doc.data().friend) codes.add(doc.data().friend); });
      const rows = await reportRows('partner_all', datestart, dateend, [], 'date');
      return _.orderBy(rows.filter(row => codes.has(row.code)), ['total'], ['desc']);
    });
  },
  async fetchContinue (context, {datestart, dateend}) {
    return activeReport(context, 'SET_USERS', async () => {
      const members = await referralMembers();
      const codes = new Set(members.map(user => user.code));
      const rows = await reportRows('continuous_deposit_all', datestart, dateend, [], 'date');
      return _.orderBy(rows.filter(row => codes.has(row.code || row.codes)), ['total'], ['desc']);
    });
  },
  async fetchUsers5 (context, {datestart, dateend}) {
    return activeReport(context, 'SET_USERS', async () => {
      const members = await referralMembers();
      const codes = new Set(members.map(user => user.code));
      const rows = await reportRows('cashback_all', datestart, dateend, [], 'date');
      return _.orderBy(rows.filter(row => codes.has(row.code)), ['waste'], ['desc']);
    });
  },
  fetchUsers5Old ({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      commit('SET_USERS', []);
      const promise1 = new Promise(async (resolve) => {
        const deposit = [];
        await firebase.firestore().collection('krungsri').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(doc.data().code){
              if(!deposit[doc.data().code]){
                deposit[doc.data().code] = 0;
              }
              deposit[doc.data().code] += Number(doc.data().qty.toString().replace(/,/g,''));
            }
          });
        });
        resolve(deposit);
      });
      const promise2 = new Promise(async (resolve) => {
        const withdraw = [];
        await firebase.firestore().collection('history').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').where('type','==','ถอน').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(!withdraw[doc.data().code]){
              withdraw[doc.data().code] = 0;
            }
            withdraw[doc.data().code] += Number(doc.data().qty.toString().replace(/,/g,''));
          });
        });
        resolve(withdraw);
      });
      const promise3 = new Promise(async(resolve) => {
        const bonus = [];
        await firebase.firestore().collection('history').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').where('status','==','ดำเนินการแล้ว').where('type','==','ฝาก').get().then((snapshot)=>{
          snapshot.forEach((doc) => {
            if(doc.data().bonus>0){
              if(!bonus[doc.data().code]){
                bonus[doc.data().code] = 0;
              }
              bonus[doc.data().code] += Number(doc.data().bonus.toString().replace(/,/g,''));
            }
          });
        });
        await firebase.firestore().collection('santaclaus').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot) => {
          snapshot.forEach((doc) => {
              if (doc.data().value > 0) {
                if(!bonus[doc.data().code]){
                  bonus[doc.data().code] = 0;
                }
                bonus[doc.data().code] += Number(doc.data().value.toString().replace(/,/g,''));
              }
          });
        });
        await firebase.firestore().collection('redeemreward').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot) => {
            snapshot.forEach((doc) => {
                if (doc.data().credit > 0) {
                  if(!bonus[doc.data().code]){
                    bonus[doc.data().code] = 0;
                  }
                  bonus[doc.data().code] += Number(doc.data().credit.toString().replace(/,/g,''));
                }
            });
        });
        await firebase.firestore().collection('roulet').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot) => {
            snapshot.forEach((doc) => {
                if (doc.data().value > 0) {
                  if(!bonus[doc.data().code]){
                    bonus[doc.data().code] = 0;
                  }
                  bonus[doc.data().code] += Number(doc.data().value.toString().replace(/,/g,''));
                }
            });
        });
        await firebase.firestore().collection('sharefriend').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot) => {
          snapshot.forEach((doc) => {
              if (doc.data().value > 0) {
                if(!bonus[doc.data().code]){
                  bonus[doc.data().code] = 0;
                }
                bonus[doc.data().code] += Number(doc.data().value.toString().replace(/,/g,''));
              }
          });
        });
        resolve(bonus);
      });
      const promise4 = new Promise(async(resolve) => {
        const waste = [];
        await firebase.firestore().collection('waste').where('month','==',datestart).get().then((snapshot)=>{
          snapshot.forEach((doc) => {
              waste[doc.data().code] = true;
          });
        });
        resolve(waste);
      });
      Promise.all([promise1, promise2, promise3, promise4]).then((values) => {
        firebase.database().ref().child('users').orderByChild('status').equalTo('Y').once('value', async (snapshot) => {
          let users = []; 
          snapshot.forEach((data) => {
            const user = data.val();
            if(values[0][user.code] || values[1][user.code] || values[2][user.code]){
              user.key = user.code+'-'+datestart;
              user.bonus = (values[2][user.code])?values[2][user.code]:0;
              user.deposit = (values[0][user.code])?values[0][user.code]:0;
              user.withdraw = (values[1][user.code])?values[1][user.code]:0;
              if(user.deposit > (user.withdraw+user.bonus))
                user.waste = Math.floor(((user.deposit-(user.withdraw+user.bonus))*5)/100);
              else
                user.waste = Math.floor(((user.deposit)*1)/100);
              if(values[3][user.code]){
                user.status = "Yes";
              }else{
                user.status = "No";
              }
              users.push(user);
            }
          });
          users = _.orderBy(users, ['waste'],['desc']);
          //users = _.orderBy(users, ['createdate'],['desc']);
          commit('SET_USERS', users);
          resolve(true)
        });
      });
    });
  },
  setStatus({ commit,state,rootState },key) {
    const {users} = state;
    for(const x in users){
      if(users[x].key === key){
        users[x].status = 'Yes';
        const month = key.split('-');
        firebase.firestore().collection('waste').doc(key).set({
          userId:users[x].userId,
          waste:users[x].waste,
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          month:month[1]+'-'+month[2],
          employee:rootState.AppActiveUser,
          deopsit:users[x].deposit,
          withdraw:users[x].withdraw,
        }).then(()=>{
          axios({
            method: "get",
            url: "https://api.ufaeasy888.com/waste/"+key,
          }).then(async response => {
              console.log(response);
          });
        });
        
        break;
      }
    }
    commit('SET_USERS', []);
    setTimeout(() => {
      commit('SET_USERS', users);
    }, 500);

  },
  async fetchDeposit (context, {datestart, dateend}) {
    return activeReport(context, 'SET_DEPOSIT', async () => {
      const members = await referralMembers();
      const codes = new Set(members.map(user => user.code));
      const rows = await reportRows('krungsri', datestart, dateend, [['status', '==', 'ดำเนินการแล้ว']]);
      return rows.filter(row => codes.has(row.code) && amount(row.qty) > 0).map(row => ({
        ...row, auto: row.employeeDisplayName || 'Auto',
        firstname_lastname: row.firstname_lastname || row.detail || '',
        date: showDate(row.date || row.createdate), createdate: showDate(row.createdate), qty: displayAmount(row.qty)
      }));
    });
  },
  async fetchWithdraw (context, {datestart, dateend}) {
    return activeReport(context, 'SET_DEPOSIT', async () => {
      const members = await referralMembers();
      const codes = new Set(members.map(user => user.code));
      const rows = await reportRows('history', datestart, dateend, [['status', '==', 'ดำเนินการแล้ว'], ['type', '==', 'ถอน']]);
      return rows.filter(row => codes.has(row.code) && amount(row.qty) > 0).map(row => ({
        ...row, firstname: row.employeeDisplayName || '', date: showDate(row.updatetime || row.createdate),
        createdate: showDate(row.createdate), qty: displayAmount(row.qty)
      }));
    });
  },
  fetchSetCredit({ commit },{datestart,dateend}) {
    return new Promise( async (resolve) => {
      await firebase.firestore().collection('setcredit').where('createdate','>=',datestart+' 00:00:00').where('createdate','<=',dateend+' 23:59:59').get().then((snapshot)=>{
        const deposit = [];
        snapshot.forEach((doc) => {
            const data = doc.data();
            if(data.employee){
              data.firstname = data.employee.firstname
            }else{
              data.firstname = ''
            }
            data.createdate = showDate(data.createdate)
            data.amount = Number(data.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            data.oldamount = Number(data.oldamount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            deposit.push(data);
        });
        commit('SET_SETCREDIT', deposit);
      });
      resolve(true)
    });
  },
  invalidateCurrentReport({state}) { invalidateReport(state); },
  invalidateRegister({state,commit}) {
    invalidateReport(state);
    commit('SET_REGISTER', []);
  },
  async fetchRegister (context, {datestart, dateend}) {
    return activeReport(context, 'SET_REGISTER', async () => {
      const result = await readSaleReport('register', datestart, dateend);
      return result.users;
    });
  },
}
function showDate (date) {
  if (!date) return '';
  const month = moment(date, 'YYYY-MM-DD HH:mm:ss').format('MMM');
  let showmonth = 'ธ.ค.';
  if(month === 'Jan'){
    showmonth = 'ม.ค.'
  }else if(month === 'Feb'){
    showmonth = 'ก.พ.'
  }else if(month === 'Mar'){
    showmonth = 'มี.ค.'
  }else if(month === 'Apr'){
    showmonth = 'เม.ย.'
  }else if(month === 'May'){
    showmonth = 'พ.ค.'
  }else if(month === 'Jun'){
    showmonth = 'มิ.ย.'
  }else if(month === 'Jul'){
    showmonth = 'ก.ค.'
  }else if(month === 'Aug'){
    showmonth = 'ส.ค.'
  }else if(month === 'Sep'){
    showmonth = 'ก.ย.'
  }else if(month === 'Oct'){
    showmonth = 'ต.ค.'
  }else if(month === 'Nov'){
    showmonth = 'พ.ย.'
  }
    return moment(date,'YYYY-MM-DD HH:mm:ss').format(`D ${showmonth},YY HH:mm`);
  // Below line will be for actual product
  // Currently it's commented due to demo purpose - Above url is for demo purpose
  // return "/apps/user/user-view/" + this.params.data.id
}

// The protected API establishes the marketing scope. Local storage and the
// member's partner flag are display data, not authorization checks.
async function referralMembers (saleCode) {
  const code = saleCode || (await readSaleContext()).code;
  const result = await firebase.database().ref('users').orderByChild('userFriendId').equalTo(code).once('value');
  const members = [];
  result.forEach(child => { if (child.val().code !== code) members.push({...child.val(), key: child.key}); });
  return members;
}
async function activeReport ({commit, state}, mutation, load) {
  const generation = invalidateReport(state);
  commit(mutation, []);
  const rows = await load();
  if (!currentReport(state, generation)) return {applied: false};
  commit(mutation, rows);
  return {applied: true};
}
async function reportRows (collection, start, end, filters = [], field = 'createdate') {
  const daily = field === 'date';
  let query = firebase.firestore().collection(collection)
    .where(field, '>=', start + (daily ? '' : ' 00:00:00'))
    .where(field, '<=', end + (daily ? '' : ' 23:59:59'));
  for (const [key, op, value] of filters) query = query.where(key, op, value);
  const result = await query.get();
  return result.docs.map(doc => doc.data());
}
function amount (value) {
  const number = Number(String(value == null ? '' : value).replace(/,/g, ''));
  return Number.isFinite(number) ? number : 0;
}
function totalsByCode (rows, field) {
  const totals = new Map();
  for (const row of rows) totals.set(row.code, (totals.get(row.code) || 0) + amount(row[field]));
  return totals;
}
function displayAmount (value) {
  return amount(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
